
import React, { useState, useEffect } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Menu from './components/Menu';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Loader from './components/Loader';
import ChatBubble from './components/ChatBubble';
import { useScrollSection } from './hooks/useScrollSection';

const App: React.FC = () => {
  const [loading, setLoading] = useState(true);
  
  // Track when users are in contact or menu sections
  const { isAnySectionVisible } = useScrollSection({
    sectionIds: ['contact', 'menu'], // Make sure these IDs exist in your components
    threshold: 0.2
  });

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 2500);
    return () => clearTimeout(timer);
  }, []);

  if (loading) {
    return <Loader />;
  }

  return (
    <div className="bg-[#0c1a18] text-[#f0e1b2]">
      <Header />
      <main>
        <Hero />
        <About />
        <Menu />
        <Contact />
      </main>
      <Footer />
      
      {/* Smart Chat Bubble - only shows when user is in contact or menu sections */}
      <ChatBubble isVisible={isAnySectionVisible} />
    </div>
  );
};

export default App;